export const PRODUCT_IMAGES_LENGTH = 5
export const PAGE_LIMIT = 10
